import { useEffect } from "react";

/**
 * Custom hook for setting page SEO (title, meta description, canonical URL)
 * Uses native document.title for reliability across React Router navigation
 */
export function useSEO({ title, description, canonical }) {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }
    
    // Update meta description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", description);
      }
    }
    
    // Update canonical URL
    if (canonical) {
      let canonicalTag = document.querySelector('link[rel="canonical"]');
      if (canonicalTag) {
        canonicalTag.setAttribute("href", canonical);
      }
    }
    
    // Cleanup - reset to default title when component unmounts (optional)
    return () => {
      // Title will be set by the next page, so no cleanup needed
    };
  }, [title, description, canonical]);
}
